// 整页 / 区块背景插画（CDN）。父元素需 position: relative（或整页时用 fixed），内容放在其后并设 relative。
import { illustrationUrl, type Illustration } from "@/lib/assets/illustrations";
import { cn } from "@/lib/cn";

export function Backdrop({ art, className }: { art: Illustration; className?: string }) {
  return <img src={illustrationUrl(art)} alt="" aria-hidden="true" draggable={false} decoding="async" className={cn("backdrop-art", className)} />;
}
